import React from "react";
import { Create, SimpleForm, TextInput, DateInput, BooleanInput, LongTextInput } from "react-admin";
import CoreShopField from "./CoreShopField";

export const CampaignCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <CoreShopField/>
        <TextInput source="title" label="Title"/>
        <BooleanInput source="active"/>
        <TextInput source="defaultCouponCode" label="Default coupon code"/>
        <LongTextInput source="defaultCouponDescription" label="Default coupon description"/>
        <DateInput source="startDate" label="startDate"/>
        <DateInput source="endDate" label="endDate"/>
        <BooleanInput source="randomCoupons"/>
        <BooleanInput source="reuseCoupons"/>
      </SimpleForm>
    </Create>
  );
};
